import React from 'react';
import { useTranslation } from 'react-i18next';
import { TemplateType } from '../TemplateType';
import usePdfContent, { PdfContentParams } from '../usePdfContent';

import Grid from '@material-ui/core/Grid';

import PdfContent from 'apps/Pdf/components/common/PdfContent';
import Title from 'apps/Pdf/components/common/Title';
import Subtitle from 'apps/Pdf/components/common/Subtitle';
import P from 'apps/Pdf/components/common/P';
import BasicData from 'apps/Pdf/components/BasicData/BasicData';
import Signature from 'apps/Pdf/components/Signature/Signature';
import Loading from 'apps/Pdf/components/common/Loading';

import useGeneralStyles from 'apps/Pdf/styles/general';
import useColorStyles from 'apps/Pdf/styles/colors';
import { IncomeOwnershipDeclarationlContent } from './IncomeOwnershiplInterface';
import { PdfCategory } from '../Interfaces';

const IncomeOwnership = (params: PdfContentParams) => {
  const styles = useGeneralStyles();
  const { t } = useTranslation();

  const pdfContent = usePdfContent<IncomeOwnershipDeclarationlContent>({
    category: PdfCategory.SIGNATURE,
    templateType: TPL_INCOME_OWNERSHIP,
    ...params,
  });
  const data = pdfContent?.data ? pdfContent.data : ({} as IncomeOwnershipDeclarationlContent);
  const colors = useColorStyles({ code: pdfContent?.data?.header.signedVia || '' });

  return pdfContent ? (
    <PdfContent errors={pdfContent?.errors} className={colors.root} onload afterLoad={params.afterLoad}>
      <Title>Prohlášení</Title>
      <Subtitle>o skutečném vlastnictví připisovaného, poukazovaného nebo vypláceného příjmu</Subtitle>

      <BasicData data={pdfContent.data!.header}>
        <div className={`${styles.twoColumns} ${styles.lines}`}>
          <Grid container>
            <Grid item xs={4}>
              Stát daňové rezidence
            </Grid>
            <Grid item xs={8} className={styles.value}>
              {t(`country_${data.taxResidency.country}`)}
            </Grid>
            <Grid item xs={4}>
              DIČ
            </Grid>
            <Grid item xs={8} className={styles.value}>
              {data.taxResidency.taxNumber.number}
            </Grid>
          </Grid>
        </div>
      </BasicData>

      <P>Zákazník prohlašuje, že k datu podpisu:</P>
      <ul className={`${styles.regularText} ${styles.list}`}>
        <li>
          je daňovým rezidentem výše uvedeného státu ve smyslu článku [4] příslušné smlouvy o zamezení dvojího zdanění
          nebo zákona č.586/1992 Sb., o daních z příjmu
        </li>
        <li>
          je skutečným vlastníkem všech příjmů připisovaných, poukazovaných či vyplacených v jeho prospěch společností
          WOOD Retail Investments a.s., Jihlavská 1558/21, Michle, 140 00 Praha 4, IČO 17818834, zapsaná v obchodním
          rejstříku vedeném Městským soudem v Praze, oddíl B, vložka 27805 (dále jen „Společnost“)
        </li>
        <li>veškeré tyto příjmy jsou dle daňového práva státu, jehož je daňovým rezidentem, považován za příjem; a</li>
        <li>
          všechny takové příjmy nejsou přiřaditelné stálé provozovně, pokud existuje, ve smyslu článku [5] příslušné
          smlouvy o zamezení dvojího zdanění
        </li>
      </ul>
      <P>
        V případě, že by se výše uvedené skutečnosti změnily, zavazuje se klient neprodleně o této skutečnosti písemně
        informovat Společnost.
      </P>
      <P>
        Klient se zavazuje nahradit Společnosti škodu anebo sankci vzniklou v důsledku uvedení údajů neodpovídajících
        skutečnosti a škodu anebo sankci způsobenou neposkytnutím informace o změnách ve&nbsp;výše uvedených údajích.
      </P>
      <P>
        Toto prohlášení je učiněno za účelem čerpání výhod plynoucích ze zákona č. 586/1992 Sb., o daních z&nbsp;příjmů,
        ve znění pozdějších předpisů, a z příslušné smlouvy o zamezení dvojího zdanění.
      </P>

      <Signature protocol={data.signedInfo} />
    </PdfContent>
  ) : params.preview ? (
    <Loading />
  ) : null;
};

const TPL_INCOME_OWNERSHIP: TemplateType = 'incomeOwnership';
export { TPL_INCOME_OWNERSHIP, IncomeOwnership };
